import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { MainMenuAgenda } from "../router/types"
import { AuthAccountsAndOrganizationsResponse } from "./request"
import type { LocationAuthData } from "./types"

export const COOKIE_LOADED = "COOKIE_LOADED"
export const cookieLoaded = (
    session: Maybe<string>,
    accountId: Maybe<string>,
    locationId: Maybe<string>,
    locationOverrideId: Maybe<string>,
    userRole: Maybe<string>,
    userId: Maybe<string>,
    userEmail: Maybe<string>,
    organizationId: Maybe<string>
) => ({
    type: COOKIE_LOADED,
    payload: {
        session: session,
        accountId: accountId,
        locationId: locationId,
        locationOverrideId: locationOverrideId,
        userRole: userRole,
        userId: userId,
        userEmail: userEmail,
        organizationId: organizationId,
    },
})

export const ACCOUNT_SELECT_REQUESTED = "ACCOUNT_SELECT_REQUESTED"
export const accountSelectRequested = (accountId: string) => {
    return {
        type: ACCOUNT_SELECT_REQUESTED,
        payload: {
            accountId: accountId,
        },
    }
}

export const ACCOUNT_SELECTED = "ACCOUNT_SELECTED"
export const accountSelected = (accountId: string) => {
    return {
        type: ACCOUNT_SELECTED,
        payload: {
            accountId: accountId,
        },
    }
}

export const ORGANIZATION_SELECTED = "ORGANIZATION_SELECTED"
export const organizationSelected = (id: string) => {
    return {
        type: ORGANIZATION_SELECTED,
        payload: {
            id: id,
        },
    }
}

export const REFETCH_DATA = "REFETCH_DATA"
export const refetchData = () => ({
    type: REFETCH_DATA,
})

export const AGENDA_MOUNTED = "agenda/mounted"
export const agendaMounted = (type: MainMenuAgenda) => ({
    type: AGENDA_MOUNTED,
    payload: {
        type: type,
    },
})

export const REDIRECT_TO_APP = "REDIRECT_TO_APP"
export const redirectToApp = (authResponse: AuthAccountsAndOrganizationsResponse) => ({
    type: REDIRECT_TO_APP,
    payload: {
        authResponse: authResponse,
    },
})

export const ACCOUNT_DOMAIN_UPDATED = "ACCOUNT_DOMAIN_UPDATED"
export const createActionAccountDomainUpdated = (accountId: string, domain: Maybe<string>) => ({
    type: ACCOUNT_DOMAIN_UPDATED,
    payload: {
        accountId: accountId,
        domain: domain,
    },
})

export const AUTH_LOCATIONS_REFRESH_REQUESTED = "authLocations/refresh/requested"
export const authLocationsRefreshRequested = (locationId: string) => ({
    type: AUTH_LOCATIONS_REFRESH_REQUESTED,
    payload: {
        locationId: locationId,
    },
})

export const AUTH_LOCATIONS_REFRESHED = "authLocations/refreshed"
export const authLocationsRefreshed = (locations: LocationAuthData[], masterListAccess: boolean) => ({
    type: AUTH_LOCATIONS_REFRESHED,
    payload: {
        locations: locations,
        masterListAccess: masterListAccess,
    },
})
